import React from 'react';
import BlastingReportList from './List'
import BlastingReportSummary from './Summary';

// list of blasting report child routes
const routes = [
  {
    path: `/`,
    exact: true,
    main: () => <BlastingReportList />,
    isProtected: true
  },
  {
    path: `/report/summary`,
    exact: true,
    main: () => <BlastingReportSummary />,
    isProtected: true
  },
  {
    path: `/:id`,
    exact: true,
    main: () => <BlastingReportList />,
    isProtected: true
  },
]

export default routes;
